import * as React from "react";
import { useEffect, useState } from "react";

import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { useTryLoginMutation } from "../../store";
import { Copyright } from "../dashboard/Copyright";
import { useAuth } from "../../hooks/useAuth";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { NewSensorDialog } from "./NewSensorDialog";
import { RegisterForm } from "./RegisterForm";

const defaultTheme = createTheme();

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [registerOpen, setRegisterOpen] = useState(false);

  const [tryLogin, result] = useTryLoginMutation();
  const { isLoading, isError } = result;

  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (auth.user.token) {
      navigate("/laitteet", { state: { from: location } });
    }
  }, [navigate, location, auth]);

  const { Id } = useParams();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    tryLogin({ email, password });
  };

  const LoginError = () => {
    return (
      <div style={{ color: "#ff0000", fontSize: "0.75em" }}>
        Tarkasta käyttäjätunnus ja salasana
      </div>
    );
  };

  const renderNewSensor = () => {
    if (Id) {
      return <NewSensorDialog handleNewAccount={() => setRegisterOpen(true)} />;
    } else {
      return <div />;
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <RegisterForm
        open={registerOpen}
        id={Id}
        close={() => setRegisterOpen(false)}
      />
      {renderNewSensor()}
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Kirjaudu sisään
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Sähköpostiosoite"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={event => setEmail(event.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Salasana"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={event => setPassword(event.target.value)}
            />
            {isError && <LoginError />}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={!!isLoading}
            >
              Kirjaudu
            </Button>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => setRegisterOpen(true)}
            >
              <Typography align={"center"} fontSize={"0.75em"}>
                Eikö vielä tiliä? Luo tili tästä.
              </Typography>
            </div>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
